const it = {
  mte_management: 'Gestione MTE',
  qr_code_reader: {
    no_front_camera: "Il dispositivo non sembra avere una fotocamera frontale",
    no_rear_camera: "Il dispositivo non sembra avere una fotocamera posteriore",
    change_camera: "Cambia fotocamera",
    error_permission: "ERRORE: Ã¨ necessario concedere il permesso di accesso alla fotocamera",
    error_no_camera: "ERRORE: nessuna fotocamera su questo dispositivo",
    error_secure_context: "ERRORE: contesto sicuro richiesto (HTTPS, localhost)",
    error_in_use: "ERRORE: la fotocamera Ã¨ giÃ  in uso?",
    error_unsuitable: "ERRORE: le fotocamere installate non sono adatte",
    error_stream_api: "ERRORE: l'API Stream non Ã¨ supportata in questo browser",
    error_secure_context_detail: "ERRORE: l'accesso alla fotocamera Ã¨ consentito solo in contesto sicuro. Utilizzare HTTPS o localhost anzichÃ© HTTP.",
    error_generic: "ERRORE: errore fotocamera ({errorName})",
    invalid_qr_code: "Codice QR non valido: non Ã¨ un ID lavoro valido"
  },
  select_user_site: "Seleziona il sito in cui si trova il nuovo utente assegnato",
  select_user_site_placeholder: "Seleziona il sito dell'utente",
  select_user_reassign_placeholder: "Seleziona un utente a cui riassegnare i lavori",
  qr_code_viewer: {
    close: "Chiudi",
    error_exporting_traveler: "Errore nell'esportazione del lavoro traveler: {title} - {info}"
  },
  tasks_header: {
    options: "Opzioni",
    progress: "Avanzamento",
    save_offline: "Salva offline",
    sync_job: "Sincronizza lavoro",
    documents: "Documenti",
    copy_from: "Copia da",
    complete_job: "Completa lavoro",
    reopen_job: "Riapri lavoro",
    job_reopened_successfully: "Lavoro riaperto con successo",
    failed_reopen_job: "Impossibile riaprire il lavoro",
    complete_job_confirmation: "Alcune attivitÃ  non sono ancora state approvate. Continuare per completarle tutte?",
    job_completed_notification: "Lavoro completato con successo. Notifica inviata a {client}"
  },
  documents: "Documenti",
  take_photo: "Scatta foto",
  saved: "Salvato",
  rat_audit_ok: "Tutti i pezzi nella tabella RAT sono stati sottoposti a controllo qualitÃ .",
  rat_audit_fail: "Alcuni pezzi nella tabella RAT non sono stati sottoposti a controllo qualitÃ .",
  upload_rat: "Carica RAT",
  forbidden_page: {
    message: 'Spiacenti, non sei autorizzato a visualizzare questa pagina.',
  },

  page_404: {
    message: '(404) Spiacenti, questa pagina non esiste.',
    click: 'Clicca',
    here: 'qui',
    to_return: 'per tornare alla pagina iniziale.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Accesso in corso...',
  },

  dashboard_page: {
    welcome: 'Benvenuto',
    intro: 'Soluzione end-to-end per l\'ispezione digitale.',
    scan_project_code: 'Scansiona codice progetto',
    new_version_available: 'Nuova versione disponibile!',
    websocket_status: 'Stato WebSocket',
    dij_version: 'Digital Inspection Jacket {version}',
    job_checked_out_offline: 'Questo lavoro Ã¨ stato estratto per uso offline.',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Crea una nuova attivitÃ ',
    back_to_product_list:
      'Dopo aver terminato qui, torna all\'Elenco modelli di prodotto per consentire ad altri di lavorare su questo modello',
    back_to_work_order_list:
      'Dopo aver terminato qui, torna all\'Elenco ordini di lavoro per consentire ad altri di lavorare su questo ordine',
    drop_file_reference_image: 'Trascina il file qui o clicca per caricare l\'immagine di riferimento',
    reference_image: 'Immagine di riferimento',
    signed_off_by: 'Approvato da {name}',
    task_not_available_offline: 'AttivitÃ  non disponibile offline',
    need_help_chat: 'Hai bisogno di aiuto? Clicca qui per chattare!',
    loading_user_roles: 'Caricamento ruoli utente...',
    loading_job_details: 'Caricamento dettagli lavoro...',
    checking_job_status: 'Verifica stato lavoro...',
    loading_job_tasks: 'Caricamento attivitÃ  lavoro...',
    deleting_task: 'Eliminazione attivitÃ ...',
    duplicating_folder: 'Duplicazione cartella...',
    select_folder_to_move: 'Seleziona cartella da spostare.',
    delete_folder_confirmation_message: 'L\'eliminazione di una cartella eliminerÃ  tutte le attivitÃ  al suo interno.',
    delete_confirmation: 'Sei sicuro di voler eliminare?',
  },

  site_edit_permission_denied: 'Non hai l\'autorizzazione per modificare i siti.',

  create_new_user_page: {
    create_new_user: 'Crea nuovo utente',
    create_user: 'Crea utente',
    firstName: 'Nome',
    lastName: 'Cognome',
    gid: 'GID',
    email: 'E-mail',
    password: 'Password',
    role: 'Ruolo',
    all_fields_required: 'Si prega di compilare tutti i campi obbligatori.',
    user_failed: 'Creazione utente fallita.',
    user_success: 'Utente creato con successo.',
    password_validation: 'Requisiti password: almeno 8 caratteri, una lettera minuscola, una lettera maiuscola, un numero, nessuna parte del nome utente.'
  },

  change_password_page: {
    change_password: 'Cambia password',
    change_user_password: 'Cambia password utente',
    password_change_success: 'Password modificata con successo',
    secret_question_success: 'Domanda segreta impostata con successo',
    password_change_fail: 'Impossibile modificare la password.',
    secret_question_fail: 'Impossibile impostare la domanda segreta',
    email: 'E-mail',
    oldPassword: 'Vecchia password',
    password: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    password_should_match: 'La nuova password e la password di conferma devono corrispondere.',
    password_validation: 'Requisiti password: almeno 8 caratteri, una lettera minuscola, una lettera maiuscola, un numero, nessuna parte dell\'e-mail.',
    passwordLowerCase: "La password deve contenere almeno un carattere minuscolo.",
    passwordUpperCase: "La password deve contenere almeno un carattere maiuscolo.",
    passwordNumber: "La password deve contenere almeno una cifra.",
    passwordMinLength: "La password deve essere lunga almeno 8 caratteri.",
    passwordNoUsernameParts: "La password non puÃ² contenere parti del nome utente."
  },

  profile_page: {
    myProfile: 'Il mio profilo',
    account: 'Account',
    preferences: 'Preferenze',
    profileUpdated: 'Profilo aggiornato con successo',
    updatePreferences: 'Aggiorna preferenze',
    updateAccount: 'Aggiorna account',
    my_name: 'Il mio nome',
    username: 'Nome utente',
    email: 'E-mail',
    location: 'Sede',
    phone_number: 'Numero di telefono',
    units: 'UnitÃ ',
    inches: 'Pollici',
    millimetres: 'Millimetri',
  },

  task_view: {
    cancel: 'Annulla',
    back: 'Indietro',
    save: 'Salva',
    delete: 'Elimina',
    deleteConfirmation: 'Sei sicuro di voler <b>eliminare</b> l\'attivitÃ  <b>{taskTitle}</b>?',
    deleteTask: 'Elimina attivitÃ ',
    manageMte: 'Registro strumentazione',
    repairAssessment: 'Valutazione riparazione',
    importAccuScan: 'Importa AccuScan',
    importLaserscan: 'Importa scansione laser',
    signOff: 'Approva',
    orderItem: 'Articolo ordine'
  },

  text_size: 'Dimensione testo',
  selection: 'Selezione',
  alignedlength: 'Lunghezza allineata',
  linearlength: 'Lunghezza lineare',
  positive_tolerance: '+ Tolleranza',
  negative_tolerance: '- Tolleranza',

  product_template_list: 'Elenco modelli di prodotto',
  work_order_list: 'Elenco ordini di lavoro',
  update: 'Aggiorna',
  order: 'Ordine',
  select_folder: 'Seleziona cartella',
  move: 'Sposta',
  add_task: 'Aggiungi attivitÃ ',
  add_folder: 'Aggiungi cartella',
  add_field: 'Aggiungi campo',
  message_order_drag: 'Ora puoi ordinare le tue attivitÃ , trascinale semplicemente',
  move_folder: 'Sposta nella cartella',
  move_selected: 'Sposta selezionati',
  select: 'Seleziona',
  delete_selected: 'Elimina selezionati',

  admin: 'Amministratore',
  editor: 'Editor',
  publisher: 'Publisher',
  inspector: 'Ispettore',
  report: 'Report',
  dashboard: 'Dashboard',
  profile: 'Profilo',
  language: 'Lingua',
  view_profile: 'Visualizza profilo',
  manage_fleet_data: 'Gestisci dati flotta',
  report_issue: 'Segnala problema',
  request_content: 'Richiedi contenuto',
  contact_us: 'Contattaci',
  forum: 'Viva Engage Forum',
  training: 'Formazione',
  log_out: 'Esci',

  choose_language: 'Scegli la lingua preferita.',

  create_new_product: 'Crea nuovo prodotto',
  task: 'AttivitÃ ',
  font_size: 'Dimensione carattere',
  title: 'Titolo',
  product_line: 'Linea di prodotti',
  original_OEM: 'OEM originale',
  original_oem: 'OEM originale',
  brand: 'Marca',
  frame_type: 'Tipo telaio',
  model: 'Modello',
  choose_files: 'Scegli file',
  ocr: 'OCR',
  part_number: 'Numero parte',
  document_number: 'Numero documento',
  revision: 'Revisione',
  cancel: 'Annulla',
  submit: 'Invia',
  delete: 'Elimina',
  save: 'Salva',
  done: 'Fatto',
  new_product_success: 'Nuovo prodotto creato con successo.',
  new_order_success: 'Nuovo ordine creato con successo!',
  new_product_fail_message: 'Errore durante la creazione del nuovo lavoro! Riprova.',
  new_order_fail_message: 'Errore durante la creazione del nuovo ordine! Riprova.',
  select_sites: 'Seleziona sedi',
  product_created_success: 'Prodotto creato con successo!',
  product_updated_success: 'Prodotto aggiornato con successo!',
  template: 'Modello',
  configuration: 'Configurazione',
  sales_force_opportunity_number: 'Numero opportunitÃ  Sales Force',
  select_all_limit_tooltip: 'Il pulsante seleziona tutto aggiungerÃ  15 modelli (limite)',
  select_all: 'Seleziona tutto',
  deselect_all: 'Deseleziona tutto',
  select_everything: 'Seleziona tutto',
  deselect_everything: 'Deseleziona tutto',
  import_limit_message: 'Sono stati importati solo 15 modelli, il limite Ã¨ stato raggiunto.',
  sorting_gmtl: 'Ordinamento secondo GMTL',

  // Tool names inside diagram
  'Selection Tool': 'Strumento di selezione',
  'Pan Viewport': 'Scorri vista',
  'Diameter': 'Diametro',
  'Run-Out': 'Runout',
  'Linear Length': 'Lunghezza lineare',
  'Visual Inspection': 'Ispezione visiva',
  'Text': 'Testo',
  'Generic Measurement': 'Misurazione generica',
  'Arrow': 'Freccia',
  'Line': 'Linea',
  'Replace Image': 'Sostituisci immagine',

  // Bubble names
  generic: 'Marcatore generico',
  generic_name: 'Nome generico',
  runout: 'Runout',
  length: 'Lunghezza',
  diameter: 'Diametro',
  arrow: 'Freccia',
  line: 'Linea',
  text: 'Testo',
  table: 'Tabella',
  replace: 'Sostituisci immagine',
  visualInspection: 'Ispezione visiva',
  visual: 'Ispezione visiva',
  'position-image': 'Posiziona immagine',
  'alignedLength': 'Lunghezza allineata',
  'linearLength': 'Lunghezza lineare',

  // Bubble properties
  label_numbers_only: 'Etichetta (solo numeri)',
  expected_value: 'Valore atteso',
  decimals: 'Decimali',
  units: 'UnitÃ ',
  inch: 'pollice',
  mm: 'mm',
  tolerance_type: 'Tipo di tolleranza',
  tolerance: 'Tolleranza',
  multiple_positions: 'Posizioni multiple',
  edit_table: 'Modifica tabella',
  orientation: 'Orientamento',
  measurement_name: 'Nome misurazione',
  visual_name: 'Nome ispezione visiva',
  marker_description: 'Descrizione',
  generic_marker_tolerance: 'Tolleranza',
  direction: 'Direzione',
  degrees: 'Gradi',
  clock: 'Orologio',
  rotate_text: 'Ruota testo',
  rubbed: 'Rigato',
  damaged: 'Danneggiato',
  pitted: 'Craterizzato',
  eroded: 'Eroso',
  high: 'Alto',
  low: 'Basso',
  medium: 'Medio',
  acceptable: 'Accettabile',
  all: 'Tutti',
  position: 'Posizione',
  tir: 'TIR',
  ok: 'Ok',
  in: 'pollice',
  iso_name: 'ISO',
  iso_grade: 'Classe ISO',
  RAT: 'RAT',
  none: 'Nessuno',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Vuoi salvare le modifiche?',
  discard: 'Scarta',
  stay: 'Rimani',
  back: 'Indietro',
  dismiss: 'Chiudi',

  import_drawing: 'Importa un disegno',
  work_order_list: 'Elenco ordini di lavoro',

  edit_name: 'Modifica nome',
  reopen: 'Riapri',

  //Instruction actions
  create_new_item: 'Crea un nuovo elemento',
  choose_one_item: ' Scegli un elemento',
  order_item: 'Ordina elemento',
  action: 'Azione',
  yes_no: 'SÃ¬/No',
  options: 'Opzione',
  add_iso: 'Aggiungi ISO',
  add_calculation: 'Aggiungi calcolo',
  recover: 'Recupera',
  loading: 'Caricamento...',
  clear_filters: 'Cancella filtri',
  job_downloaded_locally: 'Lavoro scaricato localmente',
  job_has_incomplete_data: 'Il lavoro ha dati incompleti',
  job_includes_repair_assessment: 'Questo lavoro include valutazioni di riparazione',
  text: 'Testo',
  sap_reference: 'Riferimento SAP',
  filter: 'Filtro',
  current_owner: 'Proprietario attuale',
  current_owner_date: 'Proprietario attuale / Data',

  template_list: {
    retrieving_listings: 'Recupero elenchi in base alla ricerca...',
    fetched_pages_found: 'Recuperate {batchCount} pagine finora. Trovati {size} elenchi...',
    found_listings: 'Trovati {length} elenchi corrispondenti ai criteri di ricerca.',
    failed_to_fetch_listings: 'Impossibile recuperare gli elenchi',
    loading_list: 'Caricamento di {listName}...',
    loading_list_progress: 'Caricamento di {listName}... ({processedCount}/{total})',
    loaded_list: 'Caricamento di {listName} completato',
    loading_job: 'Caricamento lavoro...',
    next_page: 'Pagina successiva',
    previous_page: 'Pagina precedente',
    page_label: 'Pagina',
    current_page: 'Pagina corrente',
    csm_repair_engineer: 'CSM / Ingegnere di riparazione',
    warning: "Avviso",
    repair_select_assistant: "Assistente Repair Select",
    how_can_i_help: "Come posso aiutarti?",
    no_results_clear_filters: "La ricerca non ha restituito risultati. Cancella i filtri per ottenere dati.",
    checked_out_by: "Estratto da {user}",
    completeness: "Completezza: {percentage}%",
    delete_confirmation_title: "ELIMINA",
    delete_confirmation_message: "Conferma l'eliminazione di {title}",
    delete_confirm_button: "Elimina",
    max_favorites_warning: "Puoi aggiungere fino a 140 lavori preferiti.",
    job_needs_sync: "Il lavoro ha dati che richiedono sincronizzazione"
  },

  languages: {
    en: 'Inglese',
    de: 'Tedesco',
    pt: 'Portoghese',
    it: 'Italiano',
  },

  copy_from_page: {
    copy_from: "Copia da",
    copying_tasks_to: "Copia attivitÃ  in \"{title}\"",
    publisher_tasks: "AttivitÃ  publisher",
    editor_tasks: "AttivitÃ  editor",
    search: "Cerca...",
    select_all_limit_tooltip: "Il pulsante seleziona tutto aggiungerÃ  30 attivitÃ  (limite)",
    select_site: "Seleziona sede",
    doc_no: "NÂ° doc.",
    sorting_gmtl_tooltip: "Ordinamento secondo GMTL",
    work_order: "Ordine di lavoro",
    duplicated_task: "AttivitÃ  duplicata",
    task_already_selected: "L'attivitÃ  '{name}' Ã¨ giÃ  selezionata",
    limit_reached: "Sono state importate solo {limit} attivitÃ , il limite Ã¨ stato raggiunto. L'ultimo modello da cui sono state prelevate attivitÃ  era: {title}"
  },

  table: 'Tabella',
  import_csv: 'Importa CSV',

  action_requested: 'Azione richiesta',
  picture_taken_is_mandatory: 'Ãˆ obbligatorio scattare una foto.',
  picture_uploaded_successfully: '{image} caricato con successo',
  picture_required: 'Foto richiesta.',
  your_question: 'La tua domanda',
  question: 'Domanda',
  options: 'Opzione',
  add_an_option: 'Aggiungi un\'opzione',
  multiple_choice: 'Scelta multipla',
  single_choice: 'Scelta singola',
  text_or_number: 'Testo o numero',

  number_of_rows: 'Numero di righe',
  number_of_columns: 'Numero di colonne',
  edit_rows: 'Modifica righe',
  edit_columns: 'Modifica colonne',
  only_numbers_and_alphabets: 'Nelle celle sono consentiti solo numeri e lettere fino a 16 caratteri',
  table_headings_not_empty: 'Le intestazioni della tabella non possono essere vuote',
  upload_diagram: 'Carica diagramma',

  yes: 'SÃ¬',
  no: 'No',

  product_template_list: 'Elenco modelli di prodotto',
  product_line: 'Linea di prodotti',
  work_order_list: 'Elenco ordini di lavoro',
  favorite_list: 'Elenco preferiti',
  search: 'Cerca',
  search_ellipsis: 'Cerca...',
  add_product: 'Aggiungi prodotto',
  title: 'Titolo',
  original_OEM: 'OEM originale',
  frame_type: 'Tipo telaio',
  model: 'Modello',
  part_number: 'Numero parte',
  location: 'Sede',
  document_number: 'Numero documento',
  revision: 'Revisione',
  created_by: 'Creato da',
  date: 'Data',
  add: 'Aggiungi',
  edit: 'Modifica',
  delete: 'Elimina',
  duplicate: 'Duplica',
  copyfrom: 'Copia da',
  nothing_here: 'Niente qui',

  project_number: 'Numero progetto',
  customer: 'Cliente',
  work_order_number: 'Numero ordine di lavoro',
  serial_number: 'Numero di serie',
  sales_force_number: 'Numero Sales Force',
  add_order: 'Aggiungi ordine',
  edit_order: 'Modifica ordine',
  original_oem_number: 'Numero OEM originale',
  freefinding: 'Rilievo libero',
  csm_label: 'Client Service Manager (CSM) / Project Manager',
  repair_engineer_label: 'Repair Engineer / Project Engineer',

  part_level: 'Livello parte',
  ignore: 'Ignora',
  component: 'Componente',
  crop_image: 'Ritaglia immagine',
  create_rat: 'Crea RAT',
  major: 'Principale',
  minor: 'Secondario',
  select_page: 'Seleziona pagina {currentPage} di {totalPages}',

  new_product_success_message: 'Nuovo prodotto creato con successo!',
  new_product_fail_message: 'Errore durante la creazione del nuovo lavoro! Riprova.',

  task_count: 'Numero attivitÃ ',
  selection_from_list: 'Se desiderato, effettua una selezione dall\'elenco',
  select_tasks: 'Seleziona attivitÃ ',
  select_products: 'Seleziona prodotti (opzionale)',

  select_all: 'Seleziona tutto',
  deselect_all: 'Deseleziona tutto',
  select_site: 'Seleziona sede',
  selected_products: 'Prodotti selezionati',
  review: 'Revisione',
  sites: 'Sedi secondarie',
  primary: 'Principale',
  secondary: 'Secondario',
  products: 'Prodotti',
  tasks: 'AttivitÃ ',
  next: 'Avanti',

  sign_off: 'Approva',
  sign_off_questions_completed: '{completed}/{total} completati.',
  sign_off_diagram_completed: 'Diagramma {percent}% completato.',
  sign_off_comments_label: 'Inserisci qui i tuoi commenti...',
  number_of_measurement_points: 'Numero di punti di misurazione',
  stage: 'Fase',
  number_of_stages: 'Numero di fasi',
  add_job_with_table_message: 'Spiacenti, non puoi aggiungere nuovi lavori poichÃ© hai selezionato un lavoro con una tabella attivitÃ  al suo interno.',
  configure_table_order: 'Configura tabella',
  no_options_part_level: 'Nessuna opzione trovata. Se vuoi crearne una, digita "Altro" e selezionalo.',
  all_configurations_done: 'Tutte le configurazioni in questo lavoro sono completate',
  finish_configuration: 'Termina questa configurazione',
  configured_jobs: 'Lavori configurati',
  version: 'Versione',
  task_completed_message: 'AttivitÃ  giÃ  approvata! Riapri per ulteriori modifiche!',

  create_task: {
    create_new_task: 'Crea nuova attivitÃ ',
    diagram: 'Diagramma',
    instruction: 'Istruzione',
    worksheet: 'Foglio di lavoro',
    task_name: 'Nome attivitÃ ',
    cancel: 'Annulla',
    done: 'Fatto',
    select_software_tool: 'Seleziona strumento software',
  },

  create_folder: {
    create_new_folder: 'Crea nuova cartella',
    folder_name: 'Nome cartella',
    select_software_tool: 'Seleziona strumento software',
    configure_new_part: 'Configura nuova parte',
    draw_no_b_plan: 'NÂ° disegno (B-Plan)',
    draw_no: 'NÂ° disegno',
    rotor_id: 'ID rotore',
    parts_list: 'Elenco parti',
    hallmark: 'Marchio',
    delete_title: 'ELIMINA',
    delete_field_confirmation: 'Eliminare il campo {label}?',
    name_prompt: 'Nome',
    field_already_exists: 'Il campo esiste giÃ .',
    failed_create_task: 'Impossibile creare una nuova attivitÃ ',
    start_of_stages: 'Inizio delle fasi',
    end_of_stages: 'Fine delle fasi',
  },

  emfProductList: {
    'workOrderList': 'Elenco ordini di lavoro',
    'search': 'Cerca',
    'addOrder': 'Aggiungi ordine',
    'next': 'Avanti',
    'previous': 'Precedente',

    'productLine': 'Linea di prodotti',
    'title': 'Titolo',
    'originalOEM': 'OEM originale',
    'frameType': 'Tipo telaio',
    'model': 'Modello',
    'partNumber': 'Numero parte',
    'customer': 'Cliente',
    'projectNumber': 'NÂ° progetto',
    'serialNumber': 'NÂ° serie',
    'workOrder': 'Ordine di lavoro',
    'salesForce': 'NÂ° opportunitÃ  Sales Force',
    'createdBy': 'Creato da',
  },

  loginSession: {
    'admin': 'Amministratore',
    'editor': 'Editor',
    'publisher': 'Publisher',
    'inspector': 'Ispettore',
    'report': 'Report',
    'dashboard': 'Dashboard',
    'language': 'Lingua',
    'profile': 'Profilo',
    'viewProfile': 'Visualizza profilo',
    'manageFleetData': 'Gestisci dati flotta',
    'reportIssue': 'Segnala problema',
    'requestContent': 'Richiedi contenuto',
    'contactUs': 'Contattaci',
    'training': 'Formazione',
    'logOut': 'Esci'
  },

  404: 'Non trovato',

  table_template: {
    create_table: 'Crea tabella',
    new_column: 'Aggiungi nuova colonna',
    new_row: 'Aggiungi nuova riga',
    delete_column: 'Elimina colonna selezionata',
    delete_row: 'Elimina riga selezionata'
  },

  calculation: {
    sum: 'Somma',
    sub: 'Sottrai',
    mult: 'Moltiplica'
  },

  duplicate_work_order_number: 'Il numero ordine di lavoro fornito Ã¨ giÃ  in uso',
  view_qr_code: 'Visualizza codice QR',
  download_qr_code: 'Scarica codice QR',
  download_traveler: 'Scarica traveler',
  include_repair_assessment: 'Includi valutazione riparazione',
  repair_assessment: 'Valutazione riparazione',
  import: 'Importa',
  import_editor_template: 'Modelli esistenti',
  import_add_excel_file: 'Aggiungi da file Excel',
  download_excel_file: 'Scarica file modello',
  export_task: 'Esporta attivitÃ ',
  saved: 'Salvato',
  not_saved: 'Non salvato',
  level: 'Livello',
  assembly: 'Assemblaggio',
  item_number: 'Numero articolo',
  part_name: 'Nome parte',
  part_number: 'Numero parte',
  quantity: 'QuantitÃ ',
  serialNumber: 'Numero di serie',
  actions: 'Azioni',
  no_records: 'Nessun record',
  repair_assessment_empty: 'La valutazione riparazione Ã¨ vuota. Inizia importando dati o aggiungendoli manualmente',
  repair_assessment_empty_readonly: 'La valutazione riparazione Ã¨ vuota.',
  close: 'Chiudi',
  close_notification: 'Chiudi notifica',
  import_add: 'Importa',
  change_log: 'Registro modifiche',

  add_row: 'Aggiungi riga',
  remove_row: 'Rimuovi riga',

  repair_assessment_excel_import_failed: 'Impossibile importare la valutazione riparazione dal file Excel',

  reuse: 'Riutilizza',
  repair: 'Ripara',
  replace: 'Sostituisci',
  missing: 'Mancante',
  client_reject: 'Rifiuto cliente',
  received: 'Ricevuto',
  quality_control_override: 'CQ',
  reviewed: 'Revisione ing.',
  comments: 'Commenti',

  findings: 'Rilievi',
  recommendations: 'Raccomandazioni',

  visual: 'Visivo',
  dim: 'Dimensionale',
  ndt: 'CND',

  summary: 'Riepilogo',
  repair_scope: 'Portata riparazione',
  estimated_labor: 'Ore stimate',

  not_repair_engineer: 'Solo gli ingegneri possono revisionare',

  pre_assembly_audit: 'Verifica pre-assemblaggio',
  donwload_rat: 'Esporta componenti',
  repair_assessment_search_empty: 'Nessun elemento disponibile.',

  delete_all: 'Elimina tutto',
  delete_all_message: 'Questo eliminerÃ  tutte le informazioni relative alla valutazione riparazione.',
  delete_major_message: 'Questo eliminerÃ  le informazioni dei componenti principali relative alla valutazione riparazione.',
  delete_minor_message: 'Questo eliminerÃ  le informazioni dei componenti secondari relative alla valutazione riparazione.',

  repair_assessment_row_locked: 'Questa riga Ã¨ bloccata da {user}',

  feature_disabled: 'Questa funzione Ã¨ disabilitata nella tua sede',

  locations: 'Sedi',

  recycle_bin: 'Cestino',
  recycle_bin_empty: 'Il cestino Ã¨ vuoto',

  task_name: 'Nome',
  task_type: 'Tipo',
  deleted_by: 'Eliminato da',
  deleted_at: 'Eliminato il',

  executing_site: 'Sede di esecuzione',

  na: 'N/D',

  owner: 'Proprietario',

  mtetype_create_title: 'Crea tipo MTE',
  mtetype_update_title: 'Aggiorna tipo MTE',

  create: 'Crea',

  name: 'Nome',
  needs_master: 'Richiede master',
  is_master: 'Ãˆ master',

  mte_type_delete_question: 'Sei sicuro di voler eliminare questo tipo MTE?',
  mte_type_delete_success: 'Tipo MTE eliminato con successo',
  mte_type_delete_fail: 'Impossibile eliminare il tipo MTE',

  mte_management: 'Registro strumentazione',
  add_using_camera: 'Aggiungi con fotocamera',
  close_camera: 'Chiudi fotocamera',
  add_manual_entry: 'Aggiungi voce manuale',
  create_external_link: 'Clicca per aggiungere file/link',
  select_file_to_link: 'Seleziona un file da collegare all\'attivit\u00e0',

  id: 'ID',
  type: 'Tipo',
  due_date: 'Data scadenza',
  master: 'Master',
  created_at: 'Creato il',

  masters: 'Master',
  non_masters: 'Altri',

  mandatory_error_message: '{field} Ã¨ obbligatorio',
  mandatory_date_must_not_be_in_past_error_message: '{field} Ã¨ obbligatorio e non deve essere nel passato',
  unique_error_message: '{field} deve essere univoco',

  task_locked_by_user: 'L\'attivitÃ  Ã¨ bloccata da {user} fino al {date}',

  clear: 'Cancella',
  surrogate: 'Sostituto',
  stop_surrogating: 'Interrompi sostituzione',

  create_new_site_page:
  {
    siteName: 'Nome sede',
    city: 'CittÃ ',
    state: 'Stato/Regione',
    country: 'Paese',
    create_new_site: 'Crea nuova sede',
    all_fields_required: 'Si prega di compilare tutti i campi obbligatori.',
    site_failed: 'Creazione sede fallita.',
    site_success: 'Sede creata con successo.',
  },

  edit_site_page:
  {
    edit_site: 'Modifica sede',
    siteName: 'Nome sede',
    city: 'CittÃ ',
    state: 'Stato/Regione',
    country: 'Paese',
    rat: 'Modello valutazione riparazione',
    mte_m: 'Registro strumentazione',
    delete: 'Elimina',
    update: 'Aggiorna',
    successMessage: 'Sede aggiornata con successo.',
    failedMessage: 'Impossibile aggiornare la sede.',
    delete_confirm: 'Sei sicuro di voler eliminare questa sede?',
    deletesite: 'Sede eliminata con successo.',
    deletefail: 'Impossibile eliminare la sede.',
  },
  site_list:
  {
    siteName: 'Nome sede',
    city: 'CittÃ ',
    state: 'Stato/Regione',
    country: 'Paese',
    DateModified: 'Data modifica'
  },
  announcement_banner:
  {
    title: 'Banner annunci',
    description: 'Configura il banner annunci.',
    status: 'Stato',
    message: 'Messaggio',
    start_date: 'Data inizio',
    end_date: 'Data fine',
    clear_action: 'Cancella',
    preview_action: 'Anteprima',
    save_action: 'Salva',
    enabled_status: 'Attivato',
    disabled_status: 'Disattivato',
    clear_question: 'Questo disattiverÃ  il banner di notifica per tutti gli utenti. Continuare?',
    end_date_error: 'La data di fine deve essere nel futuro'
  },
  edit_user_profile: {
    title: 'Profilo utente',
    user_owned_template_count: 'Questo utente Ã¨ proprietario di {count} modelli',
    user_owned_job_count: 'Questo utente Ã¨ proprietario di {count} lavori',
    reassign_jobs: 'Riassegna lavori',
    reassign_templates: 'Riassegna modelli',
    reassign_jobs_cancel: 'Annulla riassegnazione',
    reassign_job: 'Riassegna lavoro',
    confirm_reassign: 'Conferma riassegnazione',
    pending_approval_message: 'Questo utente Ã¨ in attesa di approvazione. Controlla le informazioni utente e approva il profilo per consentire all\'utente di utilizzare DIJ',
    rejected_message: 'Questo utente Ã¨ stato rifiutato e non puÃ² accedere a DIJ. L\'utente puÃ² comunque essere approvato se necessario.',
    success_message: 'Utente aggiornato con successo',
    full_name: 'Nome completo',
    email: 'E-mail',
    primary_location: 'Sede principale',
    secondary_locations: 'Sedi secondarie',
    phone_number: 'Numero di telefono',
    role: 'Ruolo',
    power_admin_role: 'Power Admin',
    placeholder_role: 'Ruolo',
    ownership: 'ProprietÃ ',
    additional_permissions: 'Autorizzazioni aggiuntive',
    enginner_review_permission: 'Revisione ingegnere',
    delete_button: 'Elimina',
    update_button: 'Aggiorna',
    approve_button: 'Approva',
    reject_button: 'Rifiuta',
    cancel_button: 'Annulla',
    approve_question: 'Stai approvando l\'utente {name} con ruolo \'{role}\' e sedi \'{locations}\'. Procedere?',
    reject_question: 'Stai rifiutando {name}. L\'utente non potrÃ  utilizzare DIJ. Procedere?',
    approve_success_message: 'L\'utente Ã¨ stato approvato con successo',
    reject_success_message: 'L\'utente Ã¨ stato rifiutato con successo',
    update_success_message: 'Le informazioni utente sono state aggiornate con successo',
    update_error_message: 'Errore durante l\'aggiornamento dell\'utente. Non hai il permesso di modificare questo utente.',
    job_reassignment_success_message: 'I modelli di proprietÃ  di questo utente sono stati riassegnati con successo',
  },
  new_user_welcome_page: {
    welcome_configurator_message: 'Benvenuto in DIJ. Seleziona le sedi rilevanti per il tuo lavoro',
    pending_approval_part1_message: 'La tua richiesta di accesso Ã¨ in attesa di approvazione.',
    pending_approval_part2_message: 'Torna piÃ¹ tardi per accedere.',
    submit: 'Invia',
  },
  user_list: {
    name: 'Nome completo',
    email: 'E-mail',
    location: 'Sede',
    role: 'Ruolo',
    last_login: 'Ultimo accesso'
  },
  users: {
    approved: 'Approvato',
    approved_description: 'L\'elenco degli utenti approvati. Questi utenti hanno pieno accesso a DIJ.',
    pending_approval: 'In attesa di approvazione',
    pending_approval_description: 'L\'elenco degli utenti da approvare. Questi utenti non possono accedere a DIJ finchÃ© il loro profilo non viene approvato.',
    todays_logins: 'Accessi di oggi',
    todays_logins_description: 'L\'elenco degli utenti che si sono connessi oggi. Si azzera ogni giorno a mezzanotte.',
    rejected: 'Rifiutato',
    rejected_description: 'L\'elenco degli utenti che durante il processo di approvazione sono stati rifiutati. Questi utenti non sanno di essere stati rifiutati.',
    inactive: 'Inattivo',
    inactive_description: 'L\'elenco degli utenti che non hanno informazioni SEPIA associate al proprio account.',
  },
  user_picker: {
    label: 'Seleziona un utente',
    placeholder: 'Digita e seleziona gli utenti disponibili',
    no_match_found: 'Nessuna corrispondenza trovata',
    email: 'E-mail',
    role: 'Ruolo'
  },

  sign_off_instruction_not_completed: 'Alcune istruzioni nell\'attivitÃ  non sono state completate. Sei sicuro di voler approvare l\'attivitÃ ? Questo bloccherÃ  l\'attivitÃ  per future modifiche.',
  sign_off_diagram_not_completed: 'Alcuni punti di ispezione nell\'attivitÃ  non sono stati completati. Sei sicuro di voler approvare l\'attivitÃ ? Questo bloccherÃ  l\'attivitÃ  per future modifiche.',

  chat_box: {
    generated_content_warning: 'Il contenuto Ã¨ generato automaticamente dall\'IA e potrebbe contenere imprecisioni',
    type_message_placeholder: 'Scrivi il tuo messaggio...',
    send: 'Invia',
    regenerate: 'Rigenera',
    please_wait: 'Attendere prego...',
    clear_local_history: 'Cancella cronologia locale',
    click_to_copy: 'Clicca per copiare',
    returning_answer: 'Restituzione risposta...',
    summary_generated: 'Riepilogo generato!',
  },
  report_template: {
    project_title: 'Titolo progetto',
    enter_project_number: 'Inserisci numero progetto',
    customer: 'Cliente',
    enter_customer_information: 'Inserisci informazioni cliente',
    customer_tag: 'Tag cliente',
    enter_customer_tag: 'Inserisci tag cliente',
    customer_po_no: 'NÂ° ordine cliente',
    unit_serial: 'Numero di serie unitÃ ',
    enter_serial_info: 'Inserisci informazioni serie',
    unit_model: 'Modello unitÃ ',
    project_number: 'Numero progetto',
    sales_force_opportunity_number: 'Numero opportunitÃ  Sales Force',
    enter_sales_force_opportunity_number: 'Inserisci numero opportunitÃ  Sales Force',
    process: 'Processo',
    enter_process: 'Inserisci processo',
    original_order_no: 'NÂ° ordine originale',
    enter_original_order_no: 'Inserisci NÂ° ordine originale',
    previous_orders: 'Ordini precedenti',
    enter_previous_orders: 'Inserisci ordini precedenti',
    contact_person_name: 'Nome referente',
    enter_contact_person_name: 'Inserisci nome referente',
    contact_person_department: 'Reparto referente',
    executive_summary: 'Sommario esecutivo',
    generate_executive_summary: 'Genera sommario esecutivo',
    repair_select: 'Selezione riparazione',
    sample_text: 'Testo di esempio:',
    sample_text_content: 'Siemens ha fornito servizi tecnici per conto di Duke Energy Carolinas LLC per ispezionare e fornire raccomandazioni di riparazione per un gruppo rotore EMM32A3N. Il gruppo rotore era stato inviato all\'impianto di riparazione Siemens di Charlotte, Carolina del Nord, per un\'ispezione in entrata.',
    revision_description: 'Descrizione revisione',
    enter_revision_description: 'Inserisci descrizione revisione',
    csm: 'CSM',
    enter_csm: 'Inserisci CSM',
    repair_engineer: 'Ingegnere riparazione',
    enter_repair_engineer: 'Inserisci ingegnere riparazione',
    major_components: 'Componenti principali',
    minor_components: 'Componenti secondari',
    work_performed_fact_finding: 'Lavori eseguiti per l\'ispezione di rilevamento',
    work_performed_repair: 'Lavori eseguiti per la riparazione',
    repairs_not_completed_recommendations_upgrades: 'Riparazioni non completate, raccomandazioni e aggiornamenti',
    appendix: 'Appendice',
  },

  report_header: {
    internal_report: 'Report interno',
    customer_report: 'Report cliente',
    exclude_items: 'Escludi elementi',
    documents: 'Documenti',
    revisions: 'Revisioni',
    description: 'Descrizione: {description}',
    download: 'Scarica',
    header: 'Intestazione',
    deviation_report: 'Report deviazioni',
    repair_assessment: 'Valutazione riparazione',
    work_performed: 'Lavori eseguiti',
    deleting_report_revision: 'Eliminazione revisione report',
    delete_revision_confirmation: 'Sei sicuro di voler <b>eliminare</b> la revisione: {fileName}, descrizione: {description}? Questa azione non puÃ² essere annullata.',
    delete_revision: 'Elimina revisione',
  },

  report_tasks: {
    table: 'TABELLA',
    form_inspection: 'ISPEZIONE MODULO',
    document_number: 'Numero documento:',
    revision: 'Revisione:',
    no_records: 'Nessun record',
    item: 'ARTICOLO',
    answer: 'RISPOSTA',
    attachments_uc: 'ALLEGATO/I',
    inspector: 'ISPETTORE',
    date: 'DATA',
    inspection_diagram: 'DIAGRAMMA ISPEZIONE',
    length_measurements: 'MISURAZIONI LUNGHEZZA',
    diameter_measurements: 'MISURAZIONI DIAMETRO',
    visual_inspection: 'ISPEZIONE VISIVA',
    generic_measurements: 'MISURAZIONI GENERICHE',
    label_uc: 'Etichetta',
    part_name_uc: 'Nome parte',
    description_uc: 'Descrizione',
    question_label: 'Domanda:',
    name_label: 'Nome:',
    description_label: 'Descrizione:',
    expected_value_uc: 'Valore atteso',
    tolerance1: 'Tolleranza1',
    tolerance2: 'Tolleranza2',
    unit: 'UnitÃ ',
    inspector_title: 'Ispettore',
    date_title: 'Data',
    condition: 'Condizione',
    severity: 'GravitÃ ',
    measurement_name_uc: 'Nome misurazione',
    runout_measurements: 'MISURAZIONI RUNOUT',
    tir: 'TIR',
    tolerance: 'Tolleranza',
    task_prefix: 'AttivitÃ :',
    show_oot_colors: 'Mostra colori fuori tolleranza',
    free_finding: 'RILIEVO LIBERO',
    attachments_plain: 'ALLEGATI',
    pictures: 'foto',
    excluded: 'escluso',
  },

  deviation_report: {
    unit_serial: 'Numero di serie unitÃ :',
    review_only: 'Solo revisione',
    action_required: 'Azione richiesta',
    assembly_bom: 'BOM dell\'assemblaggio',
    assembly_ref: 'Riferimento assemblaggio',
    item_number: 'Articolo #',
    original_pn: 'PN originale',
    actions: 'Azioni',
  },

  external_data: {
    title: 'DATI ESTERNI',
    upload_failed: 'Caricamento file fallito',
    item_uc: 'ARTICOLO',
    file_name: 'Nome file',
    print_to_report: 'Stampa nel report',
    file_type_error: 'Questo tipo di file non puÃ² essere stampato nel rapporto',
    delete: 'Elimina',
    too_many_attachments: 'Troppi allegati. Il massimo consentito Ã¨ {max} allegati.',
    upload_successful: 'Allegato caricato con successo.',
  },

  viewer_3d: {
    downloading_file: 'Download file in corso...',
    loading_file: 'Caricamento file in corso...',
    screenshot: 'Screenshot',
    select_task_screenshot: 'Seleziona un\'attivitÃ  per salvare lo screenshot:',
  },

  findings: {
    title: 'RILIEVI',
    by_inspector: 'Dell\'ispettore',
    by_reporter: 'Del reporter',
    placeholder: 'Inserisci qui i tuoi rilievi...',
  },

  close_message: 'Chiudi messaggio',
  close_banner: 'Chiudi banner',
  other: 'Altro',
  enter_an_option: 'Inserisci un\'opzione',
  tap_to_start_writing: 'Tocca per iniziare a scrivere',
  breadcrumbs: 'Breadcrumbs',
  close: 'Chiudi',

  diagram_builder: {
    repair_icon: 'Icona riparazione',
    bubble_processing: 'Bolla ancora in elaborazione',
    import_diagram: 'Importa un diagramma',
    choose_files: 'Scegli file',
    note_runout_points_missing: 'Nota: il diagramma non contiene tutti i punti di runout presenti nel file.',
    note_points_missing: 'Nota: il diagramma non contiene tutti i punti presenti nel file.',
    laserscan_import_success: 'Valori LaserScan importati con successo.',
    not_all_dij_points_filled: 'Nota: non tutti i punti DIJ sono stati compilati.',
    all_inspection_values_imported_successfully: 'Tutti i valori di ispezione importati con successo.',
    image_size: 'Dimensione immagine',
    edit_comment: 'Modifica commento',
    comment: 'Commento',
    your_comment: 'Il tuo commento',
    fine: 'Buono',
    major_component: 'Componente principale',
    minor_component: 'Componente secondario',
    label: 'Etichetta',
    expected: 'Att.',
    tolerance: 'Tol.',
    empty_diagram: 'Diagramma vuoto',
    take_photo: 'Scatta foto',
    tir: 'TIR',
    position_image: 'Posiziona immagine',
    description_options: {
      other: 'Altro',
      te_bearing_journal: 'Perno cuscinetto TE',
      nte_bearing_journal: 'Perno cuscinetto NTE',
      te_seal_fit: 'Sede tenuta TE',
      nte_seal_fit: 'Sede tenuta NTE',
      coupling_fit: 'Sede accoppiamento',
      probe_track: 'Pista sonda',
      bridgeover: 'Bridgeover',
      thrust_disc_fit: 'Sede disco spinta',
      balance_piston: 'Pistone di bilanciamento',
      overspeed_trip_fit: 'Sede sgancio sovravelocitÃ ',
      te_gland: 'Baderna TE',
      nte_gland: 'Baderna NTE',
      '1st_stg_impeller_eye': '1Â° stadio occhio girante',
      '2nd_stg_impeller_eye': '2Â° stadio occhio girante',
      '3rd_stg_impeller_eye': '3Â° stadio occhio girante',
      '4th_stg_impeller_eye': '4Â° stadio occhio girante',
      '5th_stg_impeller_eye': '5Â° stadio occhio girante',
      '6th_stg_impeller_eye': '6Â° stadio occhio girante',
      '7th_stg_impeller_eye': '7Â° stadio occhio girante',
      '8th_stg_impeller_eye': '8Â° stadio occhio girante',
      '1st_2nd_stg_spacer': 'Distanziale 1Â°-2Â° stadio',
      '2nd_3rd_stg_spacer': 'Distanziale 2Â°-3Â° stadio',
      '3rd_4th_stg_spacer': 'Distanziale 3Â°-4Â° stadio',
      '4th_5th_stg_spacer': 'Distanziale 4Â°-5Â° stadio',
      '5th_6th_stg_spacer': 'Distanziale 5Â°-6Â° stadio',
      '6th_7th_stg_spacer': 'Distanziale 6Â°-7Â° stadio',
      '7th_8th_stg_spacer': 'Distanziale 7Â°-8Â° stadio',
      journal_area_te: 'Area perno TE',
      journal_area_nte: 'Area perno NTE',
      thrust_collar_fit: 'Sede collare di spinta',
      center_balance_plane: 'Piano di bilanciamento centrale',
      rh_cplg_tpr_fit: 'Sede conico accoppiamento DX',
      lh_cplg_tpr_fit: 'Sede conico accoppiamento SX',
      extension_fit_te: 'Sede estensione TE',
      extension_fit_nte: 'Sede estensione NTE',
      exciter_fit: 'Sede eccitatore',
      fan_fit_te: 'Sede ventilatore TE',
      fan_fit_nte: 'Sede ventilatore NTE',
      dummy_piston_fit: 'Sede pistone cieco',
      oil_deflector_fit_te: 'Sede deflettore olio TE',
      oil_deflector_fit_nte: 'Sede deflettore olio NTE',
      hydrogen_seal_fit_te: 'Sede tenuta idrogeno TE',
      hydrogen_seal_fit_nte: 'Sede tenuta idrogeno NTE',
      collector_ring_fit_te: 'Sede anello collettore TE',
      collector_ring_fit_nte: 'Sede anello collettore NTE',
      te_brg_seal_area: 'Area tenuta cuscinetto TE',
      nte_brg_seal_area: 'Area tenuta cuscinetto NTE',
      thrust_runner_fit: 'Sede pattino assiale',
    },
  },

  admin_page: {
    create_new_role: 'Crea nuovo ruolo',
    new_role_name: 'Nome nuovo ruolo',
    select_software_tools: 'Seleziona strumenti software',
    edit_role: 'Modifica ruolo',
    delete: 'Elimina',
    update: 'Aggiorna',
    cancel: 'Annulla',
    save: 'Salva',
    edit: 'Modifica',
    features: "FunzionalitÃ ",
    role: "Ruolo",
    role_name: "Nome ruolo",
    add_role: "Aggiungi ruolo",
    add_site: "Aggiungi sede",
    add_mte_type: "Aggiungi tipo MTE",
    needs_master: "Richiede master",
    is_master: "Ãˆ master",
    filter: "Filtro",
    search: "Cerca...",
    all: "Tutti",
    fixes: "Correzioni",
    removals: "Rimozioni",
    permitted_tools: "Strumenti consentiti",
    date_modified: "Data modifica",
    user: "Utente",
    sites: "Sedi",
    mte_types: "Tipi MTE",
    notification_banner: "Banner notifiche",
    next: "Avanti",
    back: "Indietro",
    create_role: "Crea ruolo",
    default_role_error: "Spiacenti, non puoi modificare i ruoli predefiniti.",
    success_default: "Azione completata con successo.",
    instrumentation: 'Strumentazione',
    add_instrumentation: 'Aggiungi strumentazione',
    failed_default: "Azione fallita. Riprova.",
  },

  conflict: {
    title: 'Conflitti di versione rilevati',
    yours: 'Tua versione',
    theirs: 'Loro versione',
    done: 'Fatto',
    confirm: 'Conferma',
    cancel: 'Annulla',
    use_mine_all: 'Usa la mia per tutto',
    use_theirs_all: 'Usa la loro per tutto',
    img_reference: 'Riferimento immagine',
    keep_mine: 'Mantieni la mia',
    use_theirs: 'Usa la loro',
    unknown: 'Sconosciuto',
    last_changed_by: 'Ultima modifica di:',
  },

  instruction_view: {
    create_new: 'Crea nuovo',
    create_sub_instruction: 'Crea nuova sotto-istruzione',
    table_image_alt: 'Immagine tabella',
    image_alt: 'Immagine',
    add_option: 'Aggiungi un\'opzione',
    add_other_option: 'Aggiungi opzione "Altro"',
    manage_options: 'Gestisci opzioni',
    use_image_reference: 'Usa immagine come riferimento attivitÃ ',
    upload_image: 'Carica immagine',
    upload_image_alt: 'Immagine tabella',
    uploading: 'Caricamento in corso...',
    choose_one_item: 'Scegli un elemento',
    take_photo: 'Scatta foto',
    choose_file: 'Scegli file',
    question: 'Domanda',
    import: 'Importa',
    table: 'tabella',
    rows: 'Righe',
    columns: 'Colonne',
    csv_import_note: 'Nota: le intestazioni delle colonne devono essere nella prima riga del file CSV. L\'importazione funziona solo per file CSV, non per file Excel.',
    action_option: 'Azione',
    yes_no_option: 'SÃ¬/No',
    multiple_choice_option: 'Scelta multipla',
    single_choice_option: 'Scelta singola',
    text_number_option: 'Testo',
    table_option: 'Tabella',
    smart_table_option: 'Tabella intelligente',
    import_csv_option: 'Importa tabella CSV',
    done: 'Fatto',
  },

  shared: {
    loading: 'Caricamento...',
    no_records: 'Nessun record',
    submit: 'Invia',
    finish: 'Termina',
    select_everything: 'Seleziona tutto',
    deselect_everything: 'Deseleziona tutto',
    warning: 'Avviso',
    tasks: 'AttivitÃ ',
    task: 'AttivitÃ ',
    all: 'Tutti',
    status: 'Stato',
    signed_off_by: 'Approvato da',
    signed_off_at: 'Approvato il',
    percent_complete: '% Completato',
    tool_bar: 'Barra strumenti',
    id: 'ID',
    major_components: 'Componenti principali',
    minor_components: 'Componenti secondari',
    generated_repair_recommendations: 'Genera raccomandazioni di riparazione per questa parte',
    summarize_repair_recommendations: 'Riepiloga raccomandazioni di riparazione',
    shop_notes: 'Note officina',
    serial_number: 'Numero di serie',
    helpers: 'Assistenti',
    saved: 'Salvato',
    close: 'Chiudi',
    documents: 'Documenti',
    upload_attachments: 'Carica allegati',
    download: 'Scarica',
    upload: 'Carica',
    leadman_sign_off_required: 'Approvazione caposquadra richiesta',
    require_leadman_signing: 'Richiedi firma caposquadra',
    chat_with_rs: 'Chatta con Repair Select',
    status_complete: 'Completato',
    status_open: 'Aperto',
  },

  version_page: {
    dij_releases: "Versioni DIJ",
    features: "FunzionalitÃ ",
    fixes: "Correzioni",
    removals: "Rimozioni",
    improvements: "Miglioramenti",
    hotfix: "Hotfix",
    updates: "Aggiornamenti",
    version: "Versione",
    date: "Data",
    tag: "Tag"
  },
  common: {
    close: "Chiudi",
    save: "Salva",
    uploading_progress: "Caricamento {uploaded}/{total}"
  },
  version_form: {
    title: "Aggiungi nuova versione",
    version: "Versione",
    date: "Data",
    date_placeholder: "Clicca per selezionare una data",
    section: "Sezione",
    section_placeholder: "Seleziona una sezione",
    details: "Dettagli",
    tag: "Tag"
  },
  file_explorer: {
    select_all: 'Seleziona tutto',
    recycle_bin: 'Cestino',
    image_gallery: 'Galleria immagini',
    exclude_images: 'Escludi immagini',
    include_images: 'Includi immagini',
    attach_images: 'Allega immagini',
    restore_file: 'Ripristina file',
    root: 'Radice (/)'
  }
};

export default it;